import {IRole, IUser} from './database';
import {BaseModel} from './base.model';
import {Permission} from './permission.model';


export class Role extends BaseModel<IRole> implements IRole {
  created_at: Date | null;
  deleted_at: Date | null;
  description: string | null;
  id: number;
  is_locked: any;
  name: string;
  parent_id: number | null;
  updated_at: Date | null;
  permissions?: Permission[];

  constructor(data: IRole) {
    super(data);
    if (this.permissions) {
      this.permissions = this.permissions.map(p => new Permission(p));
    }
  }

}
